import { render, staticRenderFns } from "./ReportVulnerabilityPage.vue?vue&type=template&id=92c9b254"
import script from "./ReportVulnerabilityPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportVulnerabilityPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports